import { createDOMIdentityCollection } from "../dsCoverage/createDOMIdentityCollection.js";
import { bitmapToCoverageCount } from "../dsCoverage/utils/bitmapToCoverageCount.js";
import { createIdentityBitmap } from "../dsCoverage/utils/createIdentityBitmap.js";
import { aggregateCoverage } from "./aggregateCoverage.js";
import { dsName, TIDAL_TELEMETRY } from "./constants.js";
import { identifyElement } from "./identifyElement.js";
import { readPathDetail } from "./readPathDetail.js";
import {
  getLicenseInfo,
  getLoggingEnabled,
  getSchedulerInterval,
  getSchedulerIntervalId,
  getUrlChangeDelay,
  getUrlChangeDelayId,
  setLicenseInfo,
  setLogging,
  setSchedulerInterval,
  setSchedulerIntervalId,
  setUrlChangeDelayId
} from "./store.js";
import { defaultGetRoot, formatCoverageCounts, skipElementChildren } from "./utils.js";
const telemetryEngine = {
  aggregateCoverage,
  cancelWaitAfterUrlChange() {
    clearTimeout(getUrlChangeDelayId());
  },
  changeSchedulerInterval(interval) {
    setSchedulerInterval(interval);
    const restart = getSchedulerIntervalId() !== void 0;
    if (restart) {
      telemetryEngine.stopScheduler();
      telemetryEngine.startScheduler();
    }
  },
  // FORMATTING
  collectionToBitmap: createIdentityBitmap,
  collectionToCoverageMetrics(collection) {
    const bitmap = createIdentityBitmap(collection);
    const coverage = bitmapToCoverageCount(bitmap);
    return formatCoverageCounts(coverage);
  },
  disableLogging: () => setLogging("disabled"),
  // LOGGING
  enableLogging: () => setLogging("enabled"),
  getLicenseInfo,
  // POSTMESSAGE HELPERS
  postMessageHelpers: {
    hideUI() {
      window.postMessage({
        action: "hideUI",
        source: TIDAL_TELEMETRY
      });
    },
    showUI() {
      window.postMessage({
        action: "showUI",
        source: TIDAL_TELEMETRY
      });
    },
    toggleUI() {
      window.postMessage({
        action: "toggleUI",
        source: TIDAL_TELEMETRY
      });
    }
  },
  // MANUAL RUNNER
  async run(options = {}) {
    const { submitData, forceCalculation = true } = options;
    const enableLogging = getLoggingEnabled();
    const timingApi = enableLogging ? "performance" : void 0;
    const collection = await createDOMIdentityCollection({
      dsName,
      enableLogging,
      forceCalculation,
      getComponentIdentity: identifyElement,
      root: defaultGetRoot,
      skipElementChildren,
      timingApi
    });
    if (!collection) {
      return;
    }
    const pathDetail = readPathDetail();
    const licenseInfo = telemetryEngine.getLicenseInfo() ?? {
      product: "no-product"
    };
    const meta = {
      ...pathDetail,
      ...licenseInfo
    };
    const stats = telemetryEngine.aggregateCoverage(collection);
    if (submitData === "immediate") {
      try {
        await fetch("http://localhost:3000/telemetry", {
          body: JSON.stringify({
            ...meta,
            stats
          }),
          headers: { "Content-Type": "application/json" },
          method: "POST"
        });
      } catch {
      }
    } else if (submitData === "localStorage") {
    }
    return collection;
  },
  // METADATA
  setLicenseInfo,
  startScheduler() {
    telemetryEngine.stopScheduler();
    const id = setInterval(() => {
      telemetryEngine.run({ submitData: "immediate" });
    }, getSchedulerInterval());
    setSchedulerIntervalId(id);
  },
  stopScheduler() {
    clearInterval(getSchedulerIntervalId());
    setSchedulerIntervalId();
  },
  // SCHEDULING
  waitAfterUrlChange() {
    telemetryEngine.cancelWaitAfterUrlChange();
    const delay = getUrlChangeDelay();
    const id = setTimeout(() => {
      telemetryEngine.run({ submitData: "immediate" });
      telemetryEngine.startScheduler();
    }, delay);
    setUrlChangeDelayId(id);
  },
  // LOCAL STORAGE
  // TODO
  writeLocalStorage: () => {
  }
};
export {
  telemetryEngine
};
//# sourceMappingURL=telemetryEngine.js.map
